<template>
  <v-container fluid class="settings">
    <v-row class="flex-grow-0">
      <v-btn text
             x-small
             color="primary"
             exact
             :to="{name: 'settings'}">
        &lt;&lt; {{ $t('app_drawer.settings') }}
      </v-btn>
    </v-row>
    <v-row class="flex-grow-0">
      <h3>{{ $t('abbreviation.title') }}</h3>
      <v-btn color="primary"
             class="ml-4"
             small
             @click="exportAbbreviations">
        Export
      </v-btn>
      <v-btn color="primary"
             class="ml-4"
             small
             @click="importAbbreviations">
        Import
      </v-btn>
      <v-spacer></v-spacer>
    </v-row>
    <v-row class="flex-grow-1">
      <AbbreviationList full-height
                        :refresh-trigger.sync="refreshTrigger"></AbbreviationList>
    </v-row>
  </v-container>
</template>

<script>
import AbbreviationList from "@/components/abbreviation/AbbreviationList";
import ImportAbbreviationDialog from "@/components/abbreviation/ImportAbbreviationDialog";
import {ref} from "@vue/composition-api/dist/vue-composition-api";
import {ACTION_TYPES} from "@/store/types";

export default {
  name: 'Abbreviations',
  components: {AbbreviationList},
  setup(props, {root}) {
    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    const exportAbbreviations = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/abbreviation/export/',
        params: {},
        opt: {extra: {responseType: 'arraybuffer'}},
      });

      let disposition = response.headers.get('Content-Disposition');
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(disposition);
      let filename = matches[1].replace(/['"]/g, '');

      let blob = new Blob([response.data], {type: response.headers.get('content-type')});
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = decodeURIComponent(filename)
      link.click();
    };

    const importAbbreviations = async function () {
      await root.$dialog.showAndWait(ImportAbbreviationDialog, {
        showClose: false,
        persistent: true,
      });
      refresh();
    };

    return {
      refreshTrigger,
      refresh,
      exportAbbreviations,
      importAbbreviations,
    }
  },
}
</script>

<style lang="less">
.settings {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
